<template>
  <div class="row">
    <div class="col-12">
      <div class="card bg-secondary shadow border-0">
        <div
          v-if="verifying === true"
          class="card-body"
          style="padding: 2.5rem"
        >
          <div v-if="firstName" class="text-center">
            <h2>
              Welcome to CWHD Rewards Program, {{ firstName }}! You can now
              start earning points!
            </h2>
          </div>
          <div v-else class="text-center">
            <h2>Verifying Email ....</h2>
          </div>
        </div>
        <div v-if="hasError" class="card-body" style="padding: 2.5rem">
          <div class="text-center">
            <h2>We’re unable to verify your email at the moment. Please contact Customer Service for assistance.</h2>
            <!-- <p>
              Redirecting to <router-link :to="'login'">Login</router-link> ...
              {{ timeLeft }}
            </p> -->
          </div>
        </div>
        <div v-if="hasExpired" class="card-body" style="padding: 2.5rem">
          <div class="text-center">
            <h2>Email verification link has expired</h2>
            <!-- <p>
              Redirecting to <router-link :to="'login'">Login</router-link> ...
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'EmailVerificationSuccess',
  data() {
    return {
      verifying: true,
      firstName: null,
      verifyEmailEndpoint: '/api/v2/clp_member_accounts/verify-email',
      verifyTokenEndpoint: '/api/v2/clp_member_accounts/verify_token',
      duration: 10,
      timeLeft: 0,
      timer: null,
      hasError: false,
      hasExpired: false,
    };
  },
  methods: {
    redirectToLogin() {
      this.$router.push(`login`);
    },
    startCountdown() {
      this.timeLeft = this.duration;

      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
          this.redirectToLogin();
        }
      }, 1000);
    },
  },
  async created() {
    const token = this.$route.query.token || null;
    const url = this.verifyEmailEndpoint;
    const verifyTokenURL = this.verifyTokenEndpoint;

    try {
      // Verification of Token if valid
      const verifyTokenResponse = await HTTPRequest.postRequest(verifyTokenURL, { token: token });
      let isValid = false;
      
      if (verifyTokenResponse.status === 200) {
        isValid = true;
        this.hasExpired = false;
        this.verifying = true;
      }else{
        isValid = false;
        this.hasExpired = true;
        this.verifying = false;
        // this.startCountdown();
      }

      // Verify Email if valid
      if(isValid){
        const verificationResponse = await HTTPRequest.getRequest(url, { token: token });
        const { status, data } = verificationResponse;
        if (status === 200) {
          this.firstName = data.firstName;
          this.verifying = true;
          this.hasError = false;
        }else{
          this.hasError = true;
          this.verifying = false;
          // this.startCountdown();
        } 
      }

    } catch (error) {
      this.hasError = true;
      this.verifying = false;
      // this.startCountdown();
      console.error('Email verification failed:', error);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style scoped>
.card-body,
.card-body h2,
.card-body p,
.card-body a {
  color: #003A90 !important;
}
</style>
